import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { UserResource } from '@.api/methods';
import { Layout } from '@.layout';
import { ClusterStoreDetailService, ClusterStoreModel } from '@/Components/Pages/ServiceProviderPage/components/ClusterStoreDetail/model';
import { UserForm } from '@/Components/Partials/User';
import { Button } from '@/Components/UI';
import { LinkHelper } from '@/Services';

import { ClusterStoreDetail } from '../components/ClusterStoreDetail';
import S from './StoreClusterDetailPage.module.scss';

export const StoreClusterDetailPage = () => {
    const params = useParams();

    const [user, setUser] = useState<UserResource | null>(null);
    const [cluster, setCluster] = useState<ClusterStoreModel | null>(null);

    const spClusterId = params.id ? Number(params.id) : undefined;

    useEffect(() => {
        const loadInitialData = async (spClusterId: number) => {
            const clusterStoreService = new ClusterStoreDetailService();

            const clusterDetail = await clusterStoreService.getClusterDetail(spClusterId);

            setCluster(clusterDetail);

            if (clusterDetail.spUserId) {
                const userResource = await clusterStoreService.getUserInfoForCluster(clusterDetail.spUserId);
                setUser(userResource);
            }
        };

        if (spClusterId) {
            void loadInitialData(spClusterId);
        }
    }, [spClusterId]);

    const editHref = user ? LinkHelper.settingsUsersEditId(user.id) : '#';
    const isEditButtonDisabled = !user;

    return (
        <Layout contentClassName={S.root} nobg>
            <UserForm
                title="User Info"
                userId={user?.id}
                initialResponseUserData={user || undefined}
                isFormDisabled
                createCancelButton={() => (
                    <Button href={LinkHelper.serviceProvider.storeClusterList} color="transparent">
                        Back to list
                    </Button>
                )}
                createSaveButton={() => (
                    <Button color="brown" href={editHref} disabled={isEditButtonDisabled}>
                        Edit
                    </Button>
                )}
            />
            {cluster && <ClusterStoreDetail spCluster={cluster} />}
        </Layout>
    );
};
